import { preprod } from "src/api/config";
import { prefix } from "src/utils/users.utils";

export const strapiCheckUrl =
  (preprod && "https://supply-preprod.napitkivmeste.ru") ||
  "https://supply-mobile.napitkivmeste.ru/";

export const strapiUrl =
  (preprod && "https://supply-preprod.napitkivmeste.ru/api/") ||
  "https://supply-mobile.napitkivmeste.ru/api/";

export const strapiDefaultUrl =
  (preprod && "https://supply-preprod.napitkivmeste.ru/") ||
  "https://supply.napitkivmeste.ru/";
export const CHUNK_SIZE_USERS = 10;

// Функция для разбивки массива
export const chunkArray = (arr: string[], size: number) => {
  const chunks = [];
  for (let i = 0; i < arr.length; i += size) {
    chunks.push(arr.slice(i, i + size));
  }
  return chunks;
};

// ID - Название группы в списке Strapi - UserRoles

// ОБЩЕЕ

// 180 - Владельцы
// 184 - Участники
// 181 - Посетители
// 182 - Заводы - Администраторы
// 183 - Заводы - Директора

// MD И МТ

// 185 - Иваново - Редактор
// 186 - Иваново - Руководитель
// 187 - Калуга - Редактор
// 188 - Калуга - Руководитель
// 189 - Казань - Редактор
// 190 - Казань - Руководитель
// 191 - Клин - Редактор
// 192 - Клин - Руководитель
// 193 - Солодовня Казань - Редактор
// 194 - Солодовня Казань - Руководитель
// 195 - Солодовня Омск - Редактор
// 196 - Солодовня Омск - Руководитель
// 197 - Солодовня Саранск - Редактор
// 198 - Солодовня Саранск - Руководитель
// 199 - Новосибирск - Редактор
// 200 - Новосибирск - Руководитель
// 201 - Омск - Редактор
// 202 - Омск - Руководитель
// 203 - Регион - Редактор
// 204 - Регион - Руководитель
// 205 - Глобал - Редактор
// 206 - Глобал - Руководитель
// 207 - Саранск - Редактор
// 208 - Саранск - Руководитель
// 209 - Уфа - Редактор
// 212 - Уфа - Руководитель
// 213 - Ульяновск - Редактор
// 214 - Ульяновск - Руководитель
// 215 - Владивосток - Редактор
// 216 - Владивосток - Руководитель
// 217 - Волжский - Редактор
// 218 - Волжский - Руководитель
// 268 - Supply Incident Admin

//SECURITY

// 210 - Security Incident Admin
// 211 - Security Incident Editor

//GOS

// 219 - GOS Admin
// 220 - GOS Editor Ivanovo
// 221 - GOS Editor Kaluga
// 222 - GOS Editor Kazan
// 223 - GOS Editor Klin
// 224 - GOS Editor Novosibirsk
// 225 - GOS Editor Omsk
// 226 - GOS Editor PET Kazan
// 227 - GOS Editor Russia
// 228 - GOS Editor Saransk
// 229 - GOS Editor Solodovna Kazan
// 230 - GOS Editor Solodovna Omsk
// 231 - GOS Editor Solodovna Saransk
// 232 - GOS Editor Ufa
// 233 - GOS Editor Ulyanovsk
// 234 - GOS Editor Vladivostok
// 235 - GOS Editor Voljskiy

// VPO

// 236 - VPO Users Admin Ivanovo
// 237 - VPO Users Admin Kaluga
// 238 - VPO Users Admin Kazan
// 239 - VPO Users Admin Klin
// 240 - VPO Users Admin Novosibirsk
// 241 - VPO Users Admin Omsk
// 242 - VPO Users Admin PET Kazan
// 243 - VPO Users Admin Region
// 244 - VPO Users Admin Saransk
// 245 - VPO Users Admin Solodovna Kazan
// 246 - VPO Users Admin Solodovna Omsk
// 247 - VPO Users Admin Solodovna Saransk
// 248 - VPO Users Admin Ufa
// 249 - VPO Users Admin Ulyanovsk
// 250 - VPO Users Admin Vladivostok
// 251 - VPO Users Admin Voljskiy
// 252 - VPO Users Ivanovo
// 253 - VPO Users Kaluga
// 254 - VPO Users Kazan
// 255 - VPO Users Klin
// 256 - VPO Users Novosibirsk
// 257 - VPO Users Omsk
// 258 - VPO Users PET Kazan
// 259 - VPO Users Saransk
// 260 - VPO Users Solodovna Kazan
// 261 - VPO Users Solodovna Omsk
// 262 - VPO Users Solodovna Saransk
// 263 - VPO Users Ufa
// 264 - VPO Users Ulyanovsk
// 265 - VPO Users Vladivostok
// 266 - VPO Users Voljskiy
// 267 - VPO Users Zone

export const adminGroups = [180, 184, 5, 7];
export const incidentsAdminGroups = [268];

export const AIAccess = [270, 180, 184, 5, 7];

export const vpoUsers = [
  252, 253, 254, 255, 256, 257, 258, 259, 260, 261, 262, 263, 264, 265, 266,
  2964, 2965, 2966, 2968, 2967, 2969, 2970, 2971, 2972, 2973, 2974, 2975, 2976,
  2977, 2978,
];

export const vpoUsersZone = [267, 2991];

export const vpoUsersAdminRegion = [243, 3011];

export const vpoUsersAdmins = [
  236, 237, 238, 239, 240, 241, 242, 244, 245, 246, 247, 248, 249, 250, 251,
  2992, 2993, 2994, 2995, 2996, 2997, 2998, 2999, 3000, 3001, 3002, 3003, 3004,
  3005, 3006,
];

export const vpoUsersEditNA = [267, 243, 2991, 3011];

export const directorsSupplay = [183, 4396];

export const securityAdmins = [210, 4225];
export const securityEditors = [211, 4224];

export const vpoRelationFactoryByGroups = [
  {
    factoryID: 1, //isStrapi && 10 || 1
    factoryTitle: "Владивосток",
    directoryTitle: "BOP",
    groups: [250, 265, 3005, 2964],
  },
  {
    factoryID: 2, //isStrapi && 11 || 2
    factoryTitle: "Волжский",
    directoryTitle: "BOP",
    groups: [251, 266, 3006, 2965],
  },
  {
    factoryID: 3, //isStrapi && 1 || 3
    factoryTitle: "Иваново",
    directoryTitle: "BOP",
    groups: [236, 252, 2992, 2966],
  },
  {
    factoryID: 5, //isStrapi && 2 || 5
    factoryTitle: "Калуга",
    directoryTitle: "BOP",
    groups: [237, 253, 2993, 2968],
  },
  {
    factoryID: 4, //isStrapi && 3 || 4
    factoryTitle: "Казань",
    directoryTitle: "BOP",
    groups: [238, 254, 2994, 2967],
  },
  {
    factoryID: 6, //isStrapi && 4 || 6
    factoryTitle: "Клин",
    directoryTitle: "BOP",
    groups: [239, 255, 2995, 2969],
  },
  {
    factoryID: 7, //isStrapi && 5 || 7
    factoryTitle: "Новосибирск",
    directoryTitle: "BOP",
    groups: [240, 256, 2996, 2970],
  },
  {
    factoryID: 8, //isStrapi && 6 || 8
    factoryTitle: "Омск",
    directoryTitle: "BOP",
    groups: [241, 257, 2997, 2971],
  },
  {
    factoryID: 8, //isStrapi && 12 || 8
    factoryTitle: "ПЭТ Производство Казань",
    directoryTitle: "SOP",
    groups: [242, 258, 2998, 2972],
  },
  {
    factoryID: 10, //isStrapi && 7 || 10
    factoryTitle: "Саранск",
    directoryTitle: "BOP",
    groups: [244, 259, 2999, 2973],
  },
  {
    factoryID: 11, //isStrapi && 13 || 11
    factoryTitle: "Солодовня Казань",
    directoryTitle: "VOP",
    groups: [245, 260, 3000, 2974],
  },
  {
    factoryID: 12, //isStrapi && 14 || 12
    factoryTitle: "Солодовня Омск",
    directoryTitle: "VOP",
    groups: [246, 261, 3001, 2976],
  },
  {
    factoryID: 13, //isStrapi && 15 || 13
    factoryTitle: "Солодовня Саранск",
    directoryTitle: "VOP",
    groups: [247, 262, 3002, 2975],
  },
  {
    factoryID: 14, //isStrapi && 9 || 14
    factoryTitle: "Ульяновск",
    directoryTitle: "BOP",
    groups: [249, 264, 3004, 2977],
  },
  {
    factoryID: 15, //isStrapi && 8 || 15
    factoryTitle: "Уфа",
    directoryTitle: "BOP",
    groups: [248, 263, 3003, 2978],
  },
];

export const gosEditors = [
  220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234,
  235, 4776, 4777, 4778, 4779, 4780, 4781, 4782, 4783, 4784, 4785, 4786, 4787,
  4788, 4789, 4790, 4797,
];
export const gosAdmins = [219, 4791];
export const gosRelationFactoryByGroups = [
  {
    factoryID: 3, //isStrapi && 12 || 3
    factoryTitle: "Россия",
    groups: [227, 4797],
  },
  {
    factoryID: 11, //isStrapi && 10 || 11
    factoryTitle: "Владивосток",
    groups: [234, 4785],
  },
  {
    factoryID: 12, //isStrapi && 11 || 12
    factoryTitle: "Волжский",
    groups: [235, 4786],
  },
  {
    factoryID: 4, //isStrapi && 1 || 4
    factoryTitle: "Иваново",
    groups: [220, 4778],
  },
  {
    factoryID: 5, //isStrapi && 2 || 5
    factoryTitle: "Калуга",
    groups: [221, 4779],
  },
  {
    factoryID: 1, //isStrapi && 3 || 1
    factoryTitle: "Казань",
    groups: [222, 4776],
  },
  {
    factoryID: 6, //isStrapi && 4 || 6
    factoryTitle: "Клин",
    groups: [223, 4780],
  },
  {
    factoryID: 7, //isStrapi && 5 || 7
    factoryTitle: "Новосибирск",
    groups: [224, 4781],
  },
  {
    factoryID: 2, //isStrapi && 6 || 2
    factoryTitle: "Омск",
    groups: [225, 4777],
  },
  {
    factoryID: 16,
    factoryTitle: "ПЭТ Производство Казань",
    groups: [226, 4787],
  },
  {
    factoryID: 8, //isStrapi && 7 || 8
    factoryTitle: "Саранск",
    groups: [228, 4782],
  },
  {
    factoryID: 13,
    factoryTitle: "Солодовня Казань",
    groups: [245, 4788, 229],
  },
  {
    factoryID: 15,
    factoryTitle: "Солодовня Омск",
    groups: [246, 4789, 230],
  },
  {
    factoryID: 14,
    factoryTitle: "Солодовня Саранск",
    groups: [247, 4790, 231],
  },
  {
    factoryID: 10, //isStrapi && 9 || 10
    factoryTitle: "Ульяновск",
    groups: [233, 4784],
  },
  {
    factoryID: 9, //isStrapi && 8 || 9
    factoryTitle: "Уфа",
    groups: [232, 4783],
  },
];

export const fakeUserInfoHandle = (email: string) => {
  const tempDisplayNameArr = email.split("@")[0].split(".");
  let displayName = "";
  if (tempDisplayNameArr.length > 0) {
    if (tempDisplayNameArr.length > 1) {
      displayName =
        tempDisplayNameArr[1].charAt(0).toUpperCase() +
        tempDisplayNameArr[1].slice(1) +
        " " +
        tempDisplayNameArr[0].charAt(0).toUpperCase() +
        tempDisplayNameArr[0].slice(1);
    } else {
      displayName = tempDisplayNameArr[0];
    }
  }

  const userObj = {
    DisplayName: displayName,
    Roles: [],
    UserProfileProperties: [
      {
        Key: "abiGlobalID",
        Value: "Не активен",
      },
      {
        Key: "Manager",
        Value: "",
      },
      {
        Key: "TitleRUS",
        Value: "Не актуально",
      },
      {
        Key: "DepartmentRUS",
        Value: "Не актуально",
      },
      {
        Key: "SPS-JobTitle",
        Value: "Не активен",
      },
      {
        Key: "PreferredName",
        Value: displayName,
      },
      {
        Key: "PreferredNameRus",
        Value: displayName,
      },
    ],
    AccountName: prefix + email,
    Email: email,
    PictureUrl: null,
  };
  return userObj;
};
